var map = {
	"./building-regular.svg": "97fa",
	"./data/aboutme-info-card-data": "148d",
	"./data/aboutme-info-card-data.json": "148d",
	"./data/nav-urls": "1907",
	"./data/nav-urls.json": "1907",
	"./data/personal-resume-descriptions": "1df3",
	"./data/personal-resume-descriptions.json": "1df3",
	"./data/photography-data": "a725",
	"./data/photography-data.json": "a725",
	"./data/project-descriptions": "cc18",
	"./data/project-descriptions.json": "cc18",
	"./data/technical-experience-logos": "93cb",
	"./data/technical-experience-logos.json": "93cb",
	"./data/work-experience-descriptions": "e288",
	"./data/work-experience-descriptions.json": "e288",
	"./fonts/Heebo-Bold.ttf": "9b8b",
	"./fonts/Heebo-Medium.ttf": "c736",
	"./fonts/Heebo-Regular.ttf": "86fd",
	"./globe-americas-solid.svg": "9e0d",
	"./id-badge-regular.svg": "188d",
	"./jamesc-profile-pic.png": "5a2e",
	"./logos/angular.svg": "ef07",
	"./logos/aws.svg": "2d1b",
	"./logos/bootstrap-vue-logo.svg": "d1a1",
	"./logos/css3.svg": "12f0",
	"./logos/git.png": "bbac",
	"./logos/html5.svg": "7801",
	"./logos/javascript.svg": "ad7c",
	"./logos/python.svg": "8d6a",
	"./logos/react.svg": "6933",
	"./logos/vuejs.png": "ba04",
	"./logos/vuejs.svg": "4178",
	"./photography/thumbnail/thumb_2018-01.jpg": "f495",
	"./photography/thumbnail/thumb_2018-02.jpg": "6669",
	"./photography/thumbnail/thumb_2018-03.jpg": "2de5",
	"./photography/thumbnail/thumb_2018-04.jpg": "415d",
	"./photography/thumbnail/thumb_2018-05.jpg": "45a7",
	"./photography/thumbnail/thumb_2018-06.jpg": "9279",
	"./photography/thumbnail/thumb_2019-01.jpg": "85c9",
	"./photography/thumbnail/thumb_2019-02.jpg": "838d",
	"./photography/thumbnail/thumb_2019-03.jpg": "cb92",
	"./photography/thumbnail/thumb_2019-04.jpg": "4b50",
	"./photography/thumbnail/thumb_2019-05.jpg": "e779",
	"./photography/thumbnail/thumb_2020-01.jpg": "d3fe",
	"./photography/thumbnail/thumb_2020-02.jpg": "b489",
	"./photography/thumbnail/thumb_2020-03.jpg": "e4f3",
	"./photography/thumbnail/thumb_2020-04.jpg": "f3c9",
	"./photography/thumbnail/thumb_2020-05.jpg": "938b",
	"./photography/thumbnail/thumb_2021-01.jpg": "226e",
	"./photography/thumbnail/thumb_2021-02.jpg": "c7cc",
	"./photography/thumbnail/thumb_2021-03.jpg": "e78e",
	"./photography/thumbnail/thumb_2021-04.jpg": "e491",
	"./photography/thumbnail/thumb_2021-05.jpg": "2f43",
	"./photography/thumbnail/thumb_2021-06.jpg": "61c8",
	"./photography/thumbnail/thumb_2021-07.jpg": "8b6b",
	"./photography/thumbnail/thumb_2021-08.jpg": "13ba",
	"./photography/thumbnail/thumb_2021-09.jpg": "ed2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";